import type { ChatMember } from '../../context/chatContextCore'
import type { EntityReferenceType } from '../../types/entity'
import { useNls } from '../../nls/nlsProvider'
import { Pressable } from '../Common/Pressable'
import { getChatRoleLabel } from './chatShellChrome'

export type MentionProjectItem = {
  id: string
  title: string
  entityType: Extract<EntityReferenceType, 'ELEMENT' | 'CHECKLIST'>
  typeLabel: string
  publicId?: string | null
  color?: string | null
}

type MentionPopoverProps = {
  kind: 'MEMBER' | 'ELEMENT'
  members: ChatMember[]
  elements: MentionProjectItem[]
  onSelectMember: (member: ChatMember) => void
  onSelectElement: (element: MentionProjectItem) => void
}

export const MentionPopover = ({ kind, members, elements, onSelectMember, onSelectElement }: MentionPopoverProps) => {
  const { t } = useNls()
  const isEmpty = kind === 'MEMBER' ? members.length === 0 : elements.length === 0
  return (
    <div className="mentionPopover themeSurface" role="listbox" aria-label={kind === 'MEMBER' ? t('NLSChatAriaMentionMember') : t('NLSChatAriaMentionProjectItem')}>
      <p className="dropdownLabel">{kind === 'MEMBER' ? t('NLSChatLabelMembers') : t('NLSChatLabelProjectItems')}</p>
      {isEmpty && <p className="mentionPopoverEmpty">{t('NLSChatEmptyNoMatchingResults')}</p>}
      {kind === 'MEMBER' && members.map((member) => (
        <Pressable key={member.uid || member.id} role="option" aria-selected="false" onClick={() => onSelectMember(member)}>
          <span className="mentionPopoverAvatar" aria-hidden="true">{member.name.slice(0, 1).toUpperCase()}</span>
          <span><strong>{member.name}</strong><small>{member.email || (member.role ? getChatRoleLabel(t, member.role) : '')}</small></span>
        </Pressable>
      ))}
      {kind === 'ELEMENT' && elements.map((element) => (
        <Pressable key={element.id} role="option" aria-selected="false" onClick={() => onSelectElement(element)}>
          <span className="mentionPopoverColor" style={{ background: element.color ?? 'var(--text-strong)' }} aria-hidden="true" />
          <span><strong>{element.title}</strong><small>{element.typeLabel} · {element.publicId ?? element.id}</small></span>
        </Pressable>
      ))}
    </div>
  )
}
